import React, { lazy } from "react";

const SignIn = lazy(() => import("@/containers/LoginPages/SignIn/SignIn"));
const ResetPassword = lazy(() => import("@/containers/LoginPages/ResetPassword/ResetPassword"));
const Help = lazy(() => import("@/containers/Help/help"));

// Recovery and support must stay outside the authenticated application layout.
export const publicAuthRoutes = [
  { path: "/login", element: <SignIn /> },
  { path: "/password/reset/confirm/:uid/", element: <ResetPassword /> },
  { path: "/help", element: <Help /> },
];
